import { render, staticRenderFns } from "./spusaleBottom.vue?vue&type=template&id=e00c2dea&scoped=true&"
import script from "./spusaleBottom.vue?vue&type=script&lang=js&"
export * from "./spusaleBottom.vue?vue&type=script&lang=js&"
import style0 from "./spusaleBottom.vue?vue&type=style&index=0&id=e00c2dea&prod&lang=scss&scoped=true&"
import style1 from "./spusaleBottom.vue?vue&type=style&index=1&id=e00c2dea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00c2dea",
  null
  
)

export default component.exports